import { render, staticRenderFns } from "./visualizarSemBotao.vue?vue&type=template&id=a8448fe4&scoped=true"
import script from "./visualizarSemBotao.vue?vue&type=script&lang=js"
export * from "./visualizarSemBotao.vue?vue&type=script&lang=js"
import style0 from "./visualizarSemBotao.vue?vue&type=style&index=0&id=a8448fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8448fe4",
  null
  
)

export default component.exports